import React, { Component } from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import { Button, Card, Tooltip, notification, Select, Tabs, DatePicker, Row, Col, Checkbox, Progress, Icon, Popover } from 'antd'
import { TableComp, FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request from '../../../request'
import styles from '../../Template/all/styles.less'
import moment from 'moment'
import _, { round } from 'lodash'
import { FaServer } from "react-icons/fa";
import { connect } from "react-redux";
import { FaAmazonPay, FaRegEdit } from "react-icons/fa";
import ListFollowUps from "../../../components/_utils/listInvoiceFollowUp";
import InvoiceView from '../../../components/DocumentViews/invoiceView';
import EditInvoiceView from "../../../components/Invoice/editInvoiceView"
import InboxEmailView from '../../../components/Invoice/inboxEmailView';
import InvoiceUpdateForm from '../../../components/Invoice/invoiceUpdateForm';
import InvoiceStudentList from '../../../components/Invoice/invoiceStudentList';
import LatestFollowup from '../../../components/_utils/latestFollowup';
import async from 'async';
import GroupedPerformaInvoice from '../../../components/Invoice/groupedPerformaInvoice'
import EditNewInvoiceView from '../../../components/Invoice/editNewInvoiceView'
import GroupInvoiceChangeStatus from '../../../components/Invoice/GroupInvoiceChangeStatus'
import { RightsWrapper } from '../../../components/_utils/utils'
import userRights from '../../../components/_utils/userRights';
import UpdateInvoiceStatusRequest from '../../../components/drawers/updateInvoiceStatusRequestDrawer'
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
let companyDetails = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')) : {};
let userCheckBox = {}
let invoiceDataForGroup = {}

const Option = Select.Option
const { RangePicker, MonthPicker } = DatePicker
let invoiceObj = {};
class CollapseViewCourse extends Component {
  state = {
    cp: false,
    allUsers: [],
  }

  render() {
    const { cp } = this.state
    const clondData = this.props.children
    return <React.Fragment>
      <div>
        <div className={cp ? styles.questioncollapse : styles.questioncollapsenot}>
          {clondData && clondData.course.slice(0, cp ? (clondData.course.length) : 1).map((item) => {
            return <ul className={styles.ul}>
              <li><b>{item.courseName}{item.campusName && `(${item.campusName})`}</b></li>
              <li>{item.universityInstitutionName}</li>
              <li>
                <small>{item.univData && item.univData.universityCityId && `${item.univData.universityCityId.cityName} ,`}
                  {item.univData && item.univData.universityStateId && `${item.univData.universityStateId.stateName} ,`}
                  {item.univData && item.univData.universityCountryId && `${item.univData.universityCountryId.countryName}`}</small>
              </li>


            </ul>

          })}

        </div>
        {clondData && clondData.course && clondData.course.length > 1 ?
          <button style={{ color: 'red', float: 'right' }} onClick={() => {
            this.setState({
              cp: !cp
            })
          }}>
            {cp ? <p>View Less - </p> : <p>View More + </p>}
          </button> : null}
      </div>
    </React.Fragment>
  }
}
class AllInvoices extends Component {

  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    bonusAny: '',
    universityId: '',
    universities: [],
    courses: [],
    showInvoiveView: false,
    showEditInvoiceView: false,
    showInvoiveInboxView: false,
    showInvoiceUpdateForm: false,
    showInvoiceStudentList: false,
    generatedInvoice: {},
    universityInstitutionName: '',
    bankData: {},
    branchDetails: {},
    userCheckBox: {},
    invoiceType: '',
    invoiceStatus: '',
    invoiceData: [],
    invoiceId: '',
    branchId: '',
    branchs: [],
    channelPartners: [],
    invoiceDataForGroup: {},
    showGenerateGroupPerforma: false,
    time: null,
    courseStartDate: {
      from: '',
      to: ''
    },
    cp: false,
    showEditNewInvoiceView: false,
    showGroupInvoiceStatus: false,
    showGroupedInvoice: false,
    searchParam: null,
    showUpdateInvoiceStatus: false,
    amountTotals: {
      grossTotal: 0,
      totalTaxLiability: 0,
      netAmount: 0
    },
  }


  apiRequest = (params) => {
    return new Promise(async (resolve) => {

      params = params || {};
      params.results = 100000;
      params.count = 100000;
      params.time = this.state.time;
      params.branchId = this.state.branchId;

      if (this.state.universityInstitutionName) {
        params.universityInstitutionName = this.state.universityInstitutionName;
      }
      if (this.state.channelPartnerId) {
        params.channelPartnerId = this.state.channelPartnerId;
      }

      if (this.state.courseStartDate && this.state.courseStartDate.from) {
        params['invoices.generationActualDate'] = {
          $gte: this.state.courseStartDate.from,
          $lte: this.state.courseStartDate.to
        };
      }

      let searchParams = new URLSearchParams(this.props.search);
      let invId = searchParams.get("invId");
      let invSTId = searchParams.get("invSTId");

      let searchParam = invId ? invId : invSTId ? invSTId : null;

      let invoiceType = null;
      let invoiceStatus = null;
      let showGroupedInvoice = false;

      if (this.props.location.pathname === '/finance-desk-performa') {
        showGroupedInvoice = true;
        invoiceType = ["Performa", "Grouped Performa"];
        params.invoices = "Performa";
      } else if (this.props.location.pathname === '/finance-desk-pending') {
        invoiceStatus = 'Pending';
      } else if (this.props.location.pathname === '/finance-desk-received') {
        invoiceStatus = 'Received';
      } else if (this.props.location.pathname === '/grouped-performa-invoice') {
        invoiceType = 'Performa';
      } else if (this.props.location.pathname === "/finance-desk") {
        invoiceType = "Invoice";
      }

      if (this.state.invoiceType) {
        params.invoiceType = this.state.invoiceType;
      } else if (invoiceType) {
        params.invoiceType = invoiceType;
      }

      if (this.state.invoiceStatus) {
        params.invoiceStatus = this.state.invoiceStatus;
      } else if (invoiceStatus) {
        params.invoiceStatus = invoiceStatus;
      }

      if (invId) {
        params["_id"] = invId;
      }

      if (invSTId) {
        params["invoices.invoiceGeneratedRecordId"] = invSTId;
      }

      this.setState({ exportParams: params, showGroupedInvoice, searchParam });

      let amountTotals = {
        grossTotal: 0,
        totalTaxLiability: 0,
      }

      let response = await Request.getGeneratedInvoices({
        ...params,
        regExFilters: ['invoiceNumber'],
        sortField: 'invoiceGeneratedDate',
        sortOrder: 'descend'
      });



      /* ✅ HARD DEDUPE (invoice + student) */
      let map = {};
      let uniqueData = [];

      for (let i = 0; i < response.data.length; i++) {
        let row = response.data[i];
        amountTotals['grossTotal'] += row && row.grossPaymentReceived ? Number(row.grossPaymentReceived) : 0;
        amountTotals['totalTaxLiability'] += row && row.totalCpTax ? Number(row.totalCpTax) : 0;
        let key = row._id + "_" + row.invoiceGeneratedRecordId;

        if (!map[key]) {
          map[key] = true;
          uniqueData.push(row);
        }
      }

      response.data = uniqueData;
      // response.total = uniqueData.length;

      let employeesCheckBox = {};
      uniqueData.forEach(item => {
        employeesCheckBox[item._id] = {
          _id: item._id,
          isChecked: false,
          reviewStatus: item && item.invoiceReviewDetails && item.invoiceReviewDetails.reviewStatus ? item.invoiceReviewDetails.reviewStatus : null,
        };
      });

      userCheckBox = employeesCheckBox;

      const grossTotal = amountTotals && amountTotals.grossTotal ? amountTotals.grossTotal : 0;
      const totalTaxLiability = amountTotals && amountTotals.totalTaxLiability ? amountTotals.totalTaxLiability : 0;

      const netAmount = grossTotal - totalTaxLiability;

      this.setState({
        total: response.total,
        userCheckBox: userCheckBox,
        amountTotals: {
          grossTotal: grossTotal,
          totalTaxLiability: totalTaxLiability,
          netAmount: netAmount
        },
      });

      resolve(response);
    });
  };

  loadUniversity = async () => {
    Request.loadSimpleUniversities({ sort: { instituteName: 1 } })
      .then(resp => {
        resp.arr = resp.arr.reduce((temp, vv) => {
          temp.push({ _id: vv._id, display: vv.universityInstitutionName })
          return temp
        }, [])

        this.setState({ universities: resp.arr });
      })
      .catch(err => {
        console.log(err)
      })
  }

  loadChannelPartners = async () => {
    Request.loadChannelPartners().then(resp => {
      resp.data = resp.data.reduce((temp, vv) => {
        temp.push({ _id: vv._id, display: vv.channelPartnerName })
        return temp
      }, [])

      this.setState({ channelPartners: resp.data });
    })
      .catch(err => {
        console.log(err)
      })
  }

  generateGroupedPerformaInvoice = () => {
    let userArr = _.filter(this.state.userCheckBox, (item) => {
      return item.isChecked;
    });
    if (userArr && userArr.length) {
      invoiceDataForGroup = {
        usersData: userArr,
      }
      this.setState({ showGenerateGroupPerforma: true, invoiceDataForGroup: invoiceDataForGroup })
    } else {
      notification.error({
        message: "Please select atleast 1 Invoice.",
      });
    }
  }

  selectUser = (item, studentId) => {
    let cloneUserCheckBox = _.clone(this.state.userCheckBox);
    let reviewStatus = cloneUserCheckBox[studentId].reviewStatus;
    if (reviewStatus && (reviewStatus !== "Verified" && reviewStatus !== "Max Commission Received")) {
      notification.error({
        message: 'Invoice cannot be generated',
        description: 'The invoice review status is not verified. Please verify the review status before generating the invoice.'
      });
      return;
    }
    cloneUserCheckBox[studentId].isChecked = !cloneUserCheckBox[studentId].isChecked
    this.setState({ userCheckBox: cloneUserCheckBox });
  };


  loadApi = async () => {
    let bankData = {}
    let branchDetails = {}
    let bankDetails = await Request.getCompanyBankDetails()
    _.each(bankDetails.results, (detail) => {
      bankData[detail._id] = detail
    })
    let Apparams = {
      results: 1000,
      count: 1000,
    }
    let AssociatePartners = await Request.loadBranch(Apparams);
    _.each(AssociatePartners.data, (ap) => {
      branchDetails[ap._id] = ap
    })

    this.setState({ bankData, branchDetails })
  }

  getUpdateInvoiceStatusRequest = async () => {
    let response = await Request.getInvoiceStatusUpdateRequests();
    if (response.total > 0) {
      this.setState({ showUpdateInvoiceStatus: true })
    } else {
      this.setState({ showUpdateInvoiceStatus: false })
    }
  }

  closeUpdateStatusRequest = async () => {
    this.setState({ showUpdateInvoiceStatus: false }, () => {
      this.table.current.reload();
    })
  }


  componentWillMount() {
  }
  async componentDidMount() {

    if (userRights.checkRights('invoiceUpdateRequestNotification.view')) {
      this.getUpdateInvoiceStatusRequest();
    }

    await this.loadUniversity();
    await this.loadApi();
    await this.loadChannelPartners();
  }

  constructor(props) {
    super(props)
    this.table = React.createRef();
    this.loadBranches();
  }
  showInvoive = (record) => {
    this.setState({ showInvoiveView: true, invoiceId: record._id });
  }
  closeDocument = () => {
    this.setState({ showInvoiveView: false });
  }

  sendInvoice = (invoiceId) => {
    this.setState({ showInvoiveInboxView: true, invoiceId: invoiceId });
  }
  editInvoice = (invoiceId) => {
    this.setState({ showEditInvoiceView: true, invoiceId: invoiceId });
  }
  editNewInvoice = (invoiceId) => {
    this.setState({ showEditNewInvoiceView: true, invoiceId: invoiceId });
  }

  closeEditNewInvoice = () => {
    this.table.current.reload();
    this.setState({ showEditNewInvoiceView: false });
  }

  closeEditInvoice = () => {
    this.table.current.reload();
    this.setState({ showEditInvoiceView: false });
  }

  closeGroupedPeformaDrawer = () => {
    let $this = this;
    this.setState({ showGenerateGroupPerforma: false, invoiceDataForGroup: {} })
    setTimeout(function () {
      if ($this.table && $this.table.current) {
        $this.table.current.reload();
      }
    }, 500);
  }
  updateInvoice = (invoiceId) => {
    this.setState({ showInvoiceUpdateForm: true, invoiceId: invoiceId });
  }
  updateGroupInvoiceStatus = (invoiceId) => {
    this.setState({ showGroupInvoiceStatus: true, invoiceId: invoiceId })
  }
  showStudentList = (invoiceId) => {
    this.setState({ showInvoiceStudentList: true, invoiceId: invoiceId });
  }
  clearedInvoice = async (invoiceId, generatedInvoice, invoiceStatus = 'Cleared') => {
    let formObject = { invoiceId, invoices: generatedInvoice.invoices, invoiceStatus: invoiceStatus, invoiceReceivingDate: generatedInvoice.invoiceReceivingDate }

    let x = await Request.updateInvoiceData(formObject);
    let $this = this;
    if (!x.error) {
      notification.success({
        message: 'Invoice ' + invoiceStatus + ' successfully'
      });
      setTimeout(function () {
        if ($this.table && $this.table.current) {
          $this.table.current.reload();
        }
      }, 500);
    } else {
      notification.error({
        message: 'Error Saving',
        description: x.msg
      })
    }
  }
  createNewInvoice = async (invoiceId) => {
    let response = await Request.createNewInvoice({ invoiceId });
    if (response.error) {
      return notification.error({
        message: response.msg
      })
    } else {
      this.table.current.reload();
      return notification.success({
        message: response.msg
      })
    }
  }

  closeInvoiceInbox = () => {
    this.setState({ showInvoiveInboxView: false });
    let $this = this;
    setTimeout(function () {
      if ($this.table && $this.table.current) {
        $this.table.current.reload();
      }
    }, 500);
  }

  closeInvoiceUpdateForm = () => {
    this.setState({ showInvoiceUpdateForm: false });
    let $this = this;
    setTimeout(function () {
      if ($this.table && $this.table.current) {
        $this.table.current.reload();
      }
    }, 500);
  }
  closeGroupInvoiceStatus = () => {
    this.setState({ showGroupInvoiceStatus: false });
    let $this = this;
    setTimeout(function () {
      if ($this.table && $this.table.current) {
        $this.table.current.reload();
      }
    }, 500);
  }

  closeInvoiceStudentList = () => {
    this.setState({ showInvoiceStudentList: false });
    let $this = this;
    setTimeout(function () {
      if ($this.table && $this.table.current) {
        $this.table.current.reload();
      }
    }, 500);
  }

  loadBranches = () => {
    let params = {
      sortField: 'branchName',
      sortOrder: 'ascend',
      results: 1000,
      count: 1000,
      status: true
    }
    Request.loadBranch({ ...params })
      .then(resp => {
        resp.data = resp.data.reduce((temp, vv) => {
          temp.push({ value: vv._id, text: vv.branchName })
          return temp
        }, [])
        this.setState({ branchs: resp.data });
      })
      .catch(err => {
        console.log(err)
      })
  }

  chooseRangerPicker = (date) => {
    if (!date || !date[0] || !date[1]) {
      // If user clears the picker, reset state to null
      this.setState(
        { time: null },
        () => {
          if (this.table && this.table.current) {
            this.table.current.reload();
          }
        }
      );
    } else {
      // If valid range is selected
      this.setState(
        {
          time: {
            from: date[0],
            to: date[1],
          },
        },
        () => {
          if (this.table && this.table.current) {
            this.table.current.reload();
          }
        }
      );
    }
  };


  onOk = value => {
    if (this.table && this.table.current) {
      this.table.current.reload();
    }
  }

  openFollowUps = (record) => {
    invoiceObj = {
      invoiceToName: record.invoiceToName,
      invoiceToEmail: record.invoiceToEmail,
      _id: record._id,
    };
    this.setState({ showFollowUp: true });
  };

  closeFollowUp = () => {
    this.setState({
      showFollowUp: false,
    }, () => {
      this.table.current.reload()
    });
  };

  onChangeDatePicker = (date) => {
    this.setState(
      {
        courseStartDate: date
          ? {
            from: moment(date).startOf("month").toDate(),
            to: moment(date).endOf("month").toDate(),
          }
          : null, // 👈 if no date, reset to null
      },
      () => {
        this.table.current.reload()
      }
    );
  };


  render() {
    const { dispatch } = this.props;
    function renderInvoiceReviewStatus(record, date) {
      var reviewDetails =
        record && record.invoiceReviewDetails ? record.invoiceReviewDetails : {};

      var text = reviewDetails.reviewStatus;

      if (!text) {
        return null;
      }

      var reviewedByUser = reviewDetails.reviewedByUser
        ? reviewDetails.reviewedByUser
        : null;

      var reviewerName =
        reviewedByUser && reviewedByUser.name ? reviewedByUser.name : "";

      var rawDate =
        reviewedByUser && reviewedByUser.time
          ? reviewedByUser.time.$date
            ? reviewedByUser.time.$date
            : reviewedByUser.time
          : null;

      var labels = {
        studentRecord: "Student Record",
        intakeDate: "Intake Date",
        tutionFeeAmount: "Tuition Fee Amount",
        tutionFeePayment: "Tuition Fee Payment",
        universityOrCPinformation: "University/CP Info",
        branchOrApinformation: "Branch/AP Info",
        swiftCopy: "Swift Copy",
        piInvoiceCount: "PI Invoice Count",
        piInvoiceAmount: "PI Invoice Amount"
      };

      var totalItems = Object.keys(labels).length;
      var completedItems = Object.keys(labels).filter(function (key) {
        return reviewDetails[key] === true;
      }).length;

      var progressPercent = Math.round(
        (completedItems / totalItems) * 100
      );

      var statusClass = "bg-grey";
      var iconType = "info-circle";

      if (text === "Under Review") {
        statusClass = "bg-amber";
        iconType = "sync";
      } else if (text === "Verified") {
        statusClass = "bg-blue";
        iconType = "check-square";
      } else if (text === "Max Commission Paid") {
        statusClass = "bg-green";
        iconType = "dollar";
      }

      var popoverContent = (
        <div style={{ minWidth: "220px" }}>
          <div style={{ marginBottom: 8 }}>
            <Progress
              percent={progressPercent}
              size="small"
              format={function () {
                return completedItems + "/" + totalItems;
              }}
            />
          </div>

          {Object.keys(labels).map(function (key) {
            var done = reviewDetails[key] === true;
            return (
              <div
                key={key}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: "12px",
                  marginBottom: 4
                }}
              >
                <span>{labels[key]}</span>
                <Icon
                  type={done ? "check-circle" : "close-circle"}
                  theme={done ? "filled" : "outlined"}
                  style={{ color: done ? "#52c41a" : "#d9d9d9" }}
                />
              </div>
            );
          })}
        </div>
      );

      return (
        <div style={{ marginTop: 6 }}>
          <Popover content={popoverContent} placement="left">
            <div
              className={statusClass}
              style={{
                padding: "3px 8px",
                fontSize: "10px",
                borderRadius: 4,
                fontWeight: 700,
                display: "inline-flex",
                alignItems: "center",
                cursor: "help"
              }}
            >
              <Icon
                type={iconType}
                spin={text === "Under Review"}
                style={{ marginRight: 5 }}
              />
              {text.toUpperCase()}
            </div>
          </Popover>

          {/* {reviewerName && (
            <div style={{ fontSize: "10px", marginTop: 2 }}>
              {reviewerName}
            </div>
          )}

          {rawDate && (
            <div style={{ fontSize: "9px", color: "#8c8c8c" }}>
              {moment(rawDate).format(dateFormat + " HH:mm")}
            </div>
          )} */}
        </div>
      );
    }

    const { total, showGroupedInvoice, searchParam, cp, showInvoiveView, showEditNewInvoiceView, showEditInvoiceView, invoiceId, showInvoiveInboxView, showInvoiceUpdateForm, showGroupInvoiceStatus, showInvoiceStudentList, branchs, amountTotals, showUpdateInvoiceStatus } = this.state;
    const currencySymbols = {
      USD: "$",      // US Dollar
      EUR: "€",      // Euro
      GBP: "£",      // British Pound
      INR: "₹",      // Indian Rupee
      AUD: "A$",     // Australian Dollar
      CAD: "C$",     // Canadian Dollar
      JPY: "¥",      // Japanese Yen
      CNY: "¥",      // Chinese Yuan
      NZD: "NZ$",    // New Zealand Dollar
      CHF: "CHF",    // Swiss Franc
      SGD: "S$",     // Singapore Dollar
      HKD: "HK$",    // Hong Kong Dollar
      SEK: "kr",     // Swedish Krona
      NOK: "kr",     // Norwegian Krone
      DKK: "kr",     // Danish Krone
      ZAR: "R",      // South African Rand
      AED: "د.إ",    // UAE Dirham
      SAR: "﷼",     // Saudi Riyal
      THB: "฿",      // Thai Baht
      MYR: "RM",     // Malaysian Ringgit
      IDR: "Rp",     // Indonesian Rupiah
      KRW: "₩",      // South Korean Won
      TRY: "₺",      // Turkish Lira
      RUB: "₽",      // Russian Ruble
      BRL: "R$",     // Brazilian Real
      MXN: "$",      // Mexican Peso
      PHP: "₱",      // Philippine Peso
      PLN: "zł",     // Polish Zloty
      HUF: "Ft",     // Hungarian Forint
      CZK: "Kč",     // Czech Koruna
    };

    const columns = [
      {
        title: "S. No.",
        key: 'serialNumber',
        width: 60,
        align: 'center',
        fixed: 'left', // Keep actions accessible
        render: (text, record, index) => <span style={{ color: '#999' }}>{index + 1}</span>
      },
      {
        title: "Action",
        key: "operation",
        fixed: 'left', // Keep actions accessible
        width: 180,
        render: (text, record) => record && record.invoiceClearRequest !== "Under Review" ? (
          <div
            className={styles.btnWrapper}
            style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}
          >
            <RightsWrapper myRight="financeInvoices.edit">
              <React.Fragment>

                {/* Send invoice to recipient */}
                {(
                  !record.invoiceApprovalStatus ||
                  record.invoiceApprovalStatus === 'Approved'
                ) &&
                  (
                    (record.invoiceStatus == 'Generated' &&
                      record.invoiceType != "Performa") ||
                    (record.grouped == true &&
                      record.invoiceStatus == "Draft")
                  ) && (
                    <Tooltip title="Send invoice to recipient">
                      <Button
                        className={styles.btn}
                        onClick={() => this.sendInvoice(record._id)}
                        shape="circle"
                        icon="forward"
                      />
                    </Tooltip>
                  )}

                {(record.invoiceStatus == 'Submitted to Uni' ||
                  record.invoiceStatus == 'Approved by Uni') && (
                    <React.Fragment>

                      <Tooltip title="View Student List">
                        <Button
                          className={styles.btn}
                          onClick={() => this.showStudentList(record._id)}
                          shape="circle"
                        >
                          <FaServer />
                        </Button>
                      </Tooltip>

                      {/* Update Invoice Status */}
                      {(
                        !record.invoiceApprovalStatus ||
                        record.invoiceApprovalStatus === 'Approved'
                      ) && (
                          <Tooltip title="Update Invoice Status">
                            <Button
                              className={styles.btn}
                              onClick={() =>
                                record.structure === "new"
                                  ? this.updateGroupInvoiceStatus(record._id)
                                  : this.updateInvoice(record._id)
                              }
                              shape="circle"
                              icon="edit"
                            />
                          </Tooltip>
                        )}

                    </React.Fragment>
                  )}

                {record.invoiceStatus == 'Approved by Uni' && (
                  <Tooltip title="Approved by Uni">
                    <Button
                      className={styles.btn}
                      onClick={() =>
                        this.clearedInvoice(record._id, record, 'Paid by Uni')
                      }
                      shape="circle"
                    >
                      <FaAmazonPay style={{ width: '18px' }} />
                    </Button>
                  </Tooltip>
                )}

                {record.invoiceStatus == 'Paid by Uni' && (
                  <Tooltip title="Mark 'Paid'">
                    <Button
                      className={styles.btn}
                      onClick={() =>
                        this.clearedInvoice(record._id, record, 'Cleared')
                      }
                      shape="circle"
                      icon="check"
                    />
                  </Tooltip>
                )}

                {(record.invoiceStatus != 'Paid by Uni' &&
                  record.invoiceStatus != 'Cleared' &&
                  record.invoiceStatus != 'Original Invoice Created') && (
                    <Tooltip title="Edit Invoice">
                      <Button
                        className={styles.btn}
                        onClick={() =>
                          record.structure == "new"
                            ? this.editNewInvoice(record._id)
                            : this.editInvoice(record._id)
                        }
                        shape="circle"
                      >
                        <FaRegEdit />
                      </Button>
                    </Tooltip>
                  )}

                <Tooltip title="View Invoice">
                  <Button
                    className={styles.btn}
                    onClick={() => this.showInvoive(record)}
                    shape="circle"
                    icon="eye"
                  />
                </Tooltip>

                {(record.invoiceStatus == 'Draft' &&
                  record.invoiceType == 'Performa' &&
                  record.grouped == false) && (
                    <Tooltip title="Create Original Invoice">
                      <Button
                        className={styles.btn}
                        onClick={() => this.createNewInvoice(record._id)}
                        shape="circle"
                        icon="plus"
                      />
                    </Tooltip>
                  )}

                {record.commissionGrandTotal > 0 && (
                  <Checkbox
                    checked={
                      userCheckBox[record._id]
                        ? userCheckBox[record._id].isChecked
                        : false
                    }
                    onChange={(y) => this.selectUser(y, record._id)}
                  />
                )}

              </React.Fragment>
            </RightsWrapper>

            {(record.invoiceStatus == 'Draft' ||
              record.invoiceStatus == 'Submitted to Uni' ||
              record.invoiceStatus == 'Generated') && (
                <Tooltip title="FollowUps">
                  <Button
                    size="small"
                    shape="circle"
                    onClick={() => this.openFollowUps(record)}
                    icon="calendar"
                  />
                </Tooltip>
              )}
          </div>
        ) : <span class="text-red-600 font-semibold">
          Your Invoice Status Update Request is Under Review
        </span>
      },
      // {
      //   title: 'Invoice Details',
      //   key: 'status_logs',
      //   width: 180,
      //   searchTextName: 'Invoice Details',
      //   render: (text, record) => {
      //     // Determine the status value to check
      //     const statusValue = record.description ? record.description : record.invoiceStatus;

      //     // Status Color Map - Matches your specific statuses
      //     const statusColors = {
      //       'Generated': { bg: '#e6f7ff', text: '#1890ff', border: '#91d5ff' },        // Blue
      //       'Submitted to Uni': { bg: '#fff7e6', text: '#fa8c16', border: '#ffd591' }, // Orange
      //       'Approved by Uni': { bg: '#f9f0ff', text: '#722ed1', border: '#d3adf7' },  // Purple
      //       'Paid by Uni': { bg: '#f6ffed', text: '#52c41a', border: '#b7eb8f' },      // Green
      //       'Cleared': { bg: '#f0f5ff', text: '#2f54eb', border: '#adc6ff' },          // Navy/Cyan
      //     };
      //     // Default color if status doesn't match exactly
      //     const style = statusColors[statusValue] || { bg: '#f5f5f5', text: '#595959', border: '#d9d9d9' };

      //     return (
      //       <div>
      //         {/* 1. Invoice Number */}
      //         <div style={{ fontSize: '12px', fontWeight: 'bold', color: '#262626' }}>
      //           Inv#: {record.invoiceNumber}
      //         </div>

      //         {/* 2. Type */}
      //         <div style={{ fontSize: '11px', color: '#595959', marginTop: '2px' }}>
      //           <b>Type:</b> {record.invoiceType}
      //         </div>

      //         {/* 3. Generation Date */}
      //         <div style={{ fontSize: '10px', color: '#8c8c8c', marginBottom: '4px' }}>
      //           Gen: {record.invoiceGeneratedDate ? moment(record.invoiceGeneratedDate).format(dateFormat) : 'N/A'} | Term:{record.invoiceTerm}
      //         </div>

      //         {/* 4. Invoice Status (Dynamic Colors) */}
      //         <div style={{
      //           display: 'inline-block',
      //           padding: '2px 8px',
      //           borderRadius: '4px',
      //           background: style.bg,
      //           color: style.text,
      //           border: `1px solid ${style.border}`,
      //           fontWeight: 'bold',
      //           fontSize: '11px',
      //           textTransform: 'capitalize'
      //         }}>
      //           {statusValue}
      //         </div>
      //         <div style={{ marginTop: 4 }}>
      //           {renderInvoiceReviewStatus(record, null)}
      //         </div>
      //       </div>
      //     );
      //   }
      // },
      {
        title: 'Invoice Details',
        key: 'status_logs',
        width: 210,
        searchTextName: 'Invoice Details',
        render: (text, record) => {
          // Determine the status value to check
          const statusValue = record.description ? record.description : record.invoiceStatus;

          // Status Color Map - Matches your specific statuses
          const statusColors = {
            'Generated': { bg: '#e6f7ff', text: '#1890ff', border: '#91d5ff' },        // Blue
            'Submitted to Uni': { bg: '#fff7e6', text: '#fa8c16', border: '#ffd591' }, // Orange
            'Approved by Uni': { bg: '#f9f0ff', text: '#722ed1', border: '#d3adf7' },  // Purple
            'Paid by Uni': { bg: '#f6ffed', text: '#52c41a', border: '#b7eb8f' },      // Green
            'Cleared': { bg: '#f0f5ff', text: '#2f54eb', border: '#adc6ff' },          // Navy/Cyan
          };
          // Default color if status doesn't match exactly
          const style = statusColors[statusValue] || { bg: '#f5f5f5', text: '#595959', border: '#d9d9d9' };
          /* Safe dynamic keys evaluation since record is already the generated invoice item */
          var createdBy = record.createdByUser;
          var verifiedBy = record.invoiceReviewDetails && record.invoiceReviewDetails.reviewedByUser && record.invoiceReviewDetails.reviewStatus === "Approved" ? record.invoiceReviewDetails.reviewedByUser : (record.verifiedByUser ? record.verifiedByUser : null);
          var approvedBy = record.invoiceApprovalUpdatedBy;
          var submittedBy = record.submittedByUser;
          var clearedBy = record.clearRequestAddedBy;

          // Block condition logic check
          var dynamicWorkflowTrailHasData = !!(createdBy || verifiedBy || approvedBy || submittedBy || clearedBy);

          return (
            <div>
              {/* 1. Invoice Number */}
              <div style={{ fontSize: '12px', fontWeight: 'bold', color: '#262626' }}>
                Inv#: {record.invoiceNumber}
              </div>

              {/* 2. Type */}
              <div style={{ fontSize: '11px', color: '#595959', marginTop: '2px' }}>
                <b>Type:</b> {record.invoiceType}
              </div>

              {/* 3. Generation Date */}
              <div style={{ fontSize: '10px', color: '#8c8c8c', marginBottom: '4px' }}>
                Gen: {record.invoiceGeneratedDate ? moment(record.invoiceGeneratedDate).format(dateFormat) : 'N/A'} | Term:{record.invoiceTerm}
              </div>

              {/* 4. Invoice Status (Dynamic Colors) */}
              <div style={{
                display: 'inline-block',
                padding: '2px 8px',
                borderRadius: '4px',
                background: style.bg,
                color: style.text,
                border: `1px solid ${style.border}`,
                fontWeight: 'bold',
                fontSize: '11px',
                textTransform: 'capitalize'
              }}>
                {statusValue}
              </div>

              <div style={{ marginTop: 4 }}>
                {renderInvoiceReviewStatus(record, null)}
              </div>

              {/* WORKFLOW TRAIL BLOCK - RENDERS IF LOG DATA EXISTS CONDITIONALLY */}
              {dynamicWorkflowTrailHasData && (
                <div
                  style={{
                    background: '#fafafa',
                    borderRadius: '8px',
                    padding: '10px 12px',
                    border: '1px solid #f0f0f0',
                    fontSize: '11px',
                    marginTop: '12px'
                  }}
                >
                  <div style={{ fontWeight: 600, color: '#8c8c8c', textTransform: 'uppercase', fontSize: '9px', letterSpacing: '0.4px', marginBottom: '8px' }}>
                    Workflow Trail
                  </div>

                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', rowGap: '12px', columnGap: '14px', textAlign: 'left' }}>
                    {/* ROW 1: Created By & Verified By */}
                    {createdBy && (
                      <div>
                        <div style={{ color: '#8c8c8c' }}>Created By:</div>
                        <div style={{ color: '#262626', fontWeight: 600 }}>{createdBy.name}</div>
                        <div style={{ color: '#bfbfbf', fontSize: '10px' }}>{createdBy.time ? moment(createdBy.time).format('DD.MM.YYYY HH:mm') : ''}</div>
                      </div>
                    )}
                    {verifiedBy && (
                      <div>
                        <div style={{ color: '#8c8c8c' }}>Verified By:</div>
                        <div style={{ color: '#262626', fontWeight: 600 }}>{verifiedBy.name}</div>
                        <div style={{ color: '#bfbfbf', fontSize: '10px' }}>{verifiedBy.time ? moment(verifiedBy.time).format('DD.MM.YYYY HH:mm') : ''}</div>
                      </div>
                    )}

                    {/* ROW 2: Approved By & Submitted By */}
                    {approvedBy && (
                      <div>
                        <div style={{ color: '#8c8c8c' }}>Approved By:</div>
                        <div style={{ color: '#262626', fontWeight: 600 }}>{approvedBy.name}</div>
                        <div style={{ color: '#bfbfbf', fontSize: '10px' }}>{approvedBy.time ? moment(approvedBy.time).format('DD.MM.YYYY HH:mm') : ''}</div>
                      </div>
                    )}
                    {submittedBy && (
                      <div>
                        <div style={{ color: '#8c8c8c' }}>Submitted By:</div>
                        <div style={{ color: '#262626', fontWeight: 600 }}>{submittedBy.name}</div>
                        <div style={{ color: '#bfbfbf', fontSize: '10px' }}>{submittedBy.time ? moment(submittedBy.time).format('DD.MM.YYYY HH:mm') : ''}</div>
                      </div>
                    )}

                    {/* ROW 3: Cleared By */}
                    {clearedBy && (
                      <div style={{ gridColumn: 'span 2' }}>
                        <div style={{ color: '#8c8c8c' }}>Cleared By:</div>
                        <div style={{ color: '#262626', fontWeight: 600 }}>{clearedBy.name}</div>
                        <div style={{ color: '#bfbfbf', fontSize: '10px' }}>{clearedBy.time ? moment(clearedBy.time).format('DD.MM.YYYY HH:mm') : ''}</div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          );
        }
      },
      {
        title: "Student & Identity",
        key: 'student_info',
        width: 220,
        searchTextName: 'Student & Identity',
        render: (text, record) => (
          <div>
            <div style={{ fontWeight: 'bold', color: '#1890ff' }}>{record.studentName}</div>
            <div style={{ fontSize: '11px' }}>
              <b>VID:</b> {record.studentVisionId} | <b>PPT:</b> {record.passportNumber}
            </div>
            <div style={{ fontSize: '11px', color: '#666' }}>
              <b>ID:</b> {record.instituteStudentId} | <b>DOB:</b>{record.dateOfBirth ? moment(record.dateOfBirth).format(dateFormat) : record.inquiry ? moment(record.inquiry.dateOfBirth).format(dateFormat) : 'N/A'}
            </div>
          </div>
        )
      },
      {
        title: 'Course & University',
        key: 'academic_details',
        searchTextName: 'Course & University',
        width: 250,
        render: (text, record) => {
          let inquiry = record && record.inquiry;
          let visaDesk = inquiry && inquiry.visaDesk;
          return (
            <div style={{ fontSize: '12px' }}>

              <div style={{ fontWeight: 600 }}>{visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.universityInstitutionName}</div>
              <div style={{ color: '#555' }}>{visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.courseName}</div>
              <div style={{ color: '#888', fontSize: '11px' }}>
                CP: {visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.channelPartnerName ? visaDesk.selectedCourse.channelPartnerName : 'N/A'}
              </div>
              <div style={{ fontSize: '11px', fontStyle: 'italic' }}>
                Start:{record.courseStartDate ? moment(record.courseStartDate).format(dateFormat) : visaDesk ? moment(visaDesk.courseStartDate).format(dateFormat) : 'N/A'}
                {/* Start: {visaDesk ? moment(visaDesk.courseStartDate).format(dateFormat) : 'N/A'} */}
              </div>
            </div>
          )
        }
      },
      {
        title: 'Branch & Partners',
        key: 'branch_details',
        width: 200,
        searchTextName: 'Branch & Partners',
        render: (text, record) => {
          let visaDesk = record && record.inquiry && record.inquiry.visaDesk;
          let branchDetails = record && record.branchDetails;
          return (
            <div style={{ fontSize: '11px' }}>
              <div><b>Branch:</b> {record.studentBranchName}</div>
              <div><b>Partner:</b> {branchDetails && branchDetails.firmName ? branchDetails.firmName : record.studentBranchName}</div>
              <div style={{ marginTop: '4px', borderTop: '1px solid #eee' }}>
                <b>Visa Date:</b>{record.visaDate ? moment(record.visaDate).format(dateFormat) : visaDesk ? moment(visaDesk.visaApprovalDate).format(dateFormat) : "NA"}
                {/* <b>Visa Date:</b> {visaDesk ? moment(visaDesk.visaApprovalDate).format(dateFormat) : 'N/A'} */}
              </div>
            </div>
          )
        }
      },
      {
        title: "Financial Details (Forex)",
        key: 'financial_forex',
        width: 200,
        render: (text, record) => {
          const symbol = currencySymbols[record.currency];
          const total = Number(record && record.commissionTotal);
          return (
            <div style={{ fontSize: '12px' }}>
              <div><b>Fee:</b> {symbol}{record.tutionFee}</div>
              <div><b>Comm:</b> {record.commissionFromCourse}{record.commissionTypeFrom === "Percentage" ? "%" : " Flat"}</div>
              <div style={{ color: '#389e0d', fontWeight: 'bold' }}>
                Total: {symbol} {!isNaN(total) ? total.toFixed(2) : '0.00'}
              </div>
              <div style={{ fontSize: '10px', color: '#999' }}>Currency: {record.currency}</div>
            </div>
          )
        }
      },
      {
        title: "Converted Billing (Base)",
        key: 'billing_base',
        width: 200,
        render: (text, record) => {
          const baseSymbol = currencySymbols[
            companyDetails && companyDetails.companyCurrency
              ? companyDetails.companyCurrency
              : 'INR'
          ];

          return (
            <div style={{ fontSize: '12px', backgroundColor: '#f9f9f9', padding: '4px' }}>
              <div>
                <b>ARP Rate:</b> {baseSymbol}
                {Number(record.conversionRate || 0).toFixed(2)}
              </div>

              <div>
                <b>Before Tax:</b> {baseSymbol}
                {Number(record.commissionTotalConverted || 0).toFixed(2)}
              </div>

              <div style={{ color: '#cf1322' }}>
                <b>Tax:</b> {baseSymbol}
                {Number(record.totalCpTax || 0).toFixed(2)}
              </div>

              <div
                style={{
                  borderTop: '1px solid #d9d9d9',
                  fontWeight: 'bold',
                  marginTop: '2px'
                }}
              >
                Gross: {baseSymbol}
                {Number(
                  record.grossPaymentReceived && record.grossPaymentReceived > 0
                    ? record.grossPaymentReceived
                    : record.commissionTotalConverted || 0
                ).toFixed(2)}
              </div>
            </div>
          );
        }
      },
      {
        title: "Audit & Followup",
        key: 'audit',
        width: 180,
        render: (text, record) => (
          <div style={{ fontSize: '11px' }}>
            <div><b>By:</b> {record.createdByUser ? record.createdByUser.name : 'N/A'}</div>
            <div style={{ color: '#999', marginBottom: '5px' }}>
              {record.createdByUser && record.createdByUser.time ? moment.utc(record.createdByUser.time).local().format('lll') : ''}
            </div>
            <div style={{ borderTop: '1px solid #eee', paddingTop: '5px' }}>
              {record.inquiry && <LatestFollowup info={record.inquiry.followUp} />}
            </div>
          </div>
        )
      },
      // {
      //   title: 'Invoice Approval Status',
      //   key: 'invoiceApprovalStatus',
      //   width: 180,
      //   render: (text, record) => (
      //     <div>
      //       <div>
      //         <b>Status:</b> {record.invoiceApprovalStatus || "N/A"}
      //       </div>

      //       {record.invoiceApprovalUpdatedBy ? (
      //         <div>
      //           <b>Updated By:</b>{' '}
      //           {record.invoiceApprovalUpdatedBy
      //             ? record.invoiceApprovalUpdatedBy.name
      //             : '-'}
      //           <br />
      //           {record.invoiceApprovalUpdatedBy &&
      //             record.invoiceApprovalUpdatedBy.time
      //             ? moment(
      //               record.invoiceApprovalUpdatedBy.time
      //             ).format('DD-MM-YYYY hh:mm A')
      //             : '-'}
      //         </div>
      //       ) : null}
      //     </div>
      //   )
      // }
    ];
    return (
      <PageHeaderWrapper
        title={
          <span style={{ fontSize: '18px' }}>
            {`Invoice Desk: ${total}`}
          </span>
        }
      >
        {
          showInvoiveView ?
            <InvoiceView invoiceId={invoiceId} onClose={this.closeDocument} onSendInvoice={(invoiceId) => { this.sendInvoice(invoiceId) }} />
            : null
        }
        {
          showUpdateInvoiceStatus ?
            <UpdateInvoiceStatusRequest onClose={this.closeUpdateStatusRequest} />
            : null
        }
        {
          this.state.showGenerateGroupPerforma ?
            <GroupedPerformaInvoice invoiceIds={this.state.invoiceDataForGroup} onClose={this.closeGroupedPeformaDrawer} />
            : null
        }
        {
          showEditInvoiceView ?
            <EditInvoiceView invoiceId={invoiceId} onClose={this.closeEditInvoice} />
            : null
        }

        {
          showEditNewInvoiceView ?
            <EditNewInvoiceView invoiceId={invoiceId} onClose={this.closeEditNewInvoice} />
            : null
        }

        {
          showInvoiveInboxView ?
            <InboxEmailView invoiceId={invoiceId} onClose={this.closeInvoiceInbox} />
            : null
        }

        {
          showInvoiceUpdateForm ?
            <InvoiceUpdateForm invoiceId={invoiceId} onClose={this.closeInvoiceUpdateForm} />
            : null
        }
        {
          showGroupInvoiceStatus ?
            <GroupInvoiceChangeStatus invoiceId={invoiceId} onClose={this.closeGroupInvoiceStatus} />

            : null
        }

        {
          showInvoiceStudentList ?
            <InvoiceStudentList invoiceId={invoiceId} onClose={this.closeInvoiceStudentList} />
            : null
        }

        {
          this.state.showFollowUp ? (
            <ListFollowUps invoiceObj={invoiceObj} onClose={this.closeFollowUp} />
          )
            : null
        }
        <Card style={{ marginBottom: 10 }}
          title="Search Filters"
          headStyle={{ paddingTop: '5px' }}
          bordered={false}>
          <Row>
            <Col span={8}>
              <h4>Search By University</h4>
              <Select
                allowClear
                style={{ width: '90%' }}
                showSearch={true}
                placeholder="Select University"
                optionFilterProp="universityInstitutionName"
                onChange={(v) => this.setState({ universityInstitutionName: v }, () => {
                  this.table.current.reload();
                })}
                filterOption={(input, option) => {
                  return (
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  )
                }}>
                {
                  this.state.universities.map((val, idn) => {
                    return (
                      <Option key={idn} value={val.display}>
                        {val.display}
                      </Option>
                    );
                  })
                }
              </Select>
            </Col>
            <Col span={8}>
              <h4>Search By Channel Partner</h4>
              <Select
                allowClear
                style={{ width: '90%' }}
                showSearch={true}
                placeholder="Select Channel Partner"
                onChange={(v) => this.setState({ channelPartnerId: v }, () => {
                  this.table.current.reload();
                })}
                filterOption={(input, option) => {
                  return (
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  )
                }}>
                {
                  this.state.channelPartners.map((val, idn) => {
                    return (
                      <Option key={idn} value={val._id}>
                        {val.display}
                      </Option>
                    );
                  })
                }
              </Select>
            </Col>
            <Col span={8}>
              <h4>Filter by Date</h4>
              <RangePicker
                style={{ width: '90%' }}
                showTime={{ format: 'HH:mm' }}
                format="YYYY-MM-DD HH:mm"
                placeholder={['Start Date', 'End Date']}
                onChange={this.chooseRangerPicker}
                onOk={this.onOk}
              />
            </Col>
            <Col span={8}>
              <h4>Search By Intake</h4>
              <MonthPicker style={{ width: '90%' }} format="YYYY-MMM" onChange={this.onChangeDatePicker} placeholder="Select Intake" />
            </Col>
            <Col span={8} style={{ marginTop: '10px' }}>
              <div>
                <h4>Show By Branch/Partner</h4>
                <Select
                  allowClear
                  style={{ width: '90%' }}
                  showSearch={true}
                  value={this.state.branchId}
                  placeholder="Select Option"
                  optionFilterProp="display"
                  filterOption={(input, option) => {
                    return (
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    )
                  }}
                  onChange={branchId => {
                    this.setState(
                      {
                        branchId: branchId && branchId.toString()
                      },
                      () => {
                        setTimeout(() => {
                          this.table.current.reload();
                        }, 500);
                      }
                    )
                  }}>
                  {branchs.map((val, idn) => {
                    return (
                      <Option key={idn} value={val.value}>
                        {val.text}
                      </Option>
                    )
                  })}
                </Select>
              </div>
            </Col>

            <Col span={8} style={{ marginTop: '10px' }}>
              <h4>Search By Status</h4>
              <Select
                allowClear
                style={{ width: '90%' }}
                showSearch={true}
                placeholder="Select Status"
                optionFilterProp="invoiceStatus"
                onChange={(v) => this.setState({ invoiceStatus: v }, () => {
                  this.table.current.reload();
                })}
                filterOption={(input, option) => {
                  return (
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  )
                }}>
                {
                  ['Generated', 'Submitted to Uni/CP', 'Approved by Uni/CP', 'Paid by Uni', 'Cleared'].map((val, idn) => {
                    return (
                      <Option key={idn} value={val}>
                        {val}
                      </Option>
                    );
                  })
                }
              </Select>
            </Col>
            <Col span={8} style={{ marginTop: '10px' }}>
              <h4>Search By Invoice Type</h4>
              <Select
                allowClear
                style={{ width: '90%' }}
                showSearch={true}
                placeholder="Select Type"
                optionFilterProp="invoiceType"
                onChange={(v) => this.setState({ invoiceType: v }, () => {
                  this.table.current.reload();
                })}
                filterOption={(input, option) => {
                  return (
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  )
                }}>
                {
                  ['GST Invoice', 'Currency Invoice'].map((val, idn) => {
                    return (
                      <Option key={idn} value={val}>
                        {val}
                      </Option>
                    );
                  })
                }
              </Select>
            </Col>
          </Row>
        </Card>
        {
          showGroupedInvoice ?
            <RightsWrapper myRight="financeInvoices.edit" >
              <Card bordered={true}>
                <Button type='primary' onClick={this.generateGroupedPerformaInvoice}>Generate Final Invoice</Button>
                {
                  searchParam ? (
                    <Button style={{ marginLeft: 20 }} type='primary' onClick={() => window.open(this.props.location.pathname)}>
                      View All Invoices
                    </Button>
                  ) : null
                }
              </Card>
            </RightsWrapper>
            : null
        }
        {
          this.props.location.pathname !== "/finance-desk-performa" ?
            <Card
              bordered={true}
              style={{
                width: searchParam ? '100%' : 'fit-content',
                minWidth: '240px',
                borderRadius: '8px',
                borderLeft: '4px solid #1890ff',
                boxShadow: 'none',
                marginBottom: 10,
              }}
              bodyStyle={{ padding: '16px 20px' }}
            >
              <div style={{ display: 'flex', gap: '40px' }}>

                {/* ✅ TOTAL AMOUNT */}
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span style={{ fontSize: '12px', textTransform: 'uppercase', color: '#8c8c8c', letterSpacing: '1px', fontWeight: 600 }}>
                    Gross Amount
                  </span>

                  <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#262626', display: 'flex', alignItems: 'baseline', gap: '6px' }}>
                    <span style={{ fontSize: '18px', fontWeight: '500', color: '#595959' }}>
                      {currencySymbols[companyDetails && companyDetails.companyCurrency ? companyDetails.companyCurrency : 'INR']}
                    </span>

                    <span>
                      {amountTotals && amountTotals.grossTotal.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                    </span>
                  </div>
                </div>

                {/* ✅ TOTAL LIABILITY */}
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span style={{ fontSize: '12px', textTransform: 'uppercase', color: '#8c8c8c', letterSpacing: '1px', fontWeight: 600 }}>
                    Total Tax Liability
                  </span>

                  <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#ff4d4f', display: 'flex', alignItems: 'baseline', gap: '6px' }}>
                    <span style={{ fontSize: '18px', fontWeight: '500', color: '#595959' }}>
                      {currencySymbols[companyDetails && companyDetails.companyCurrency ? companyDetails.companyCurrency : 'INR']}
                    </span>

                    <span>
                      {amountTotals && amountTotals.totalTaxLiability.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                    </span>
                  </div>
                </div>

                {/* Net Amount Due */}
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span style={{ fontSize: '12px', textTransform: 'uppercase', color: '#8c8c8c', letterSpacing: '1px', fontWeight: 600 }}>
                    Net Amount
                  </span>

                  <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#008000', display: 'flex', alignItems: 'baseline', gap: '6px' }}>
                    <span style={{ fontSize: '18px', fontWeight: '500', color: '#595959' }}>
                      {currencySymbols[companyDetails && companyDetails.companyCurrency ? companyDetails.companyCurrency : 'INR']}
                    </span>

                    <span>
                      {amountTotals && amountTotals.netAmount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                    </span>
                  </div>
                </div>
                {
                  searchParam ? (
                    <div style={{ marginLeft: 'auto' }}>
                      <Button type='primary' onClick={() => window.open(this.props.location.pathname)}>
                        View All Invoices
                      </Button>
                    </div>
                  ) : null
                }

              </div>
            </Card>


            : null
        }


        <Card bordered={true}>
          {/* <TableComp
            key="invoiceTable"
            ref={this.table}
            columns={columns}
            apiRequest={this.apiRequest}
            extraProps={{ scroll: { x: 900 } }}
            pagination={{
            showSizeChanger: true,
            defaultPageSize: 10,
            pageSizeOptions: ['10', '20', '50', '100', '1000']
            }}
            /> */}
          <TableComp
            key="invoiceTable"
            ref={this.table}
            columns={columns}
            apiRequest={this.apiRequest}
            rowKey={(record) => {
              return record._id + "_" + record.invoiceGeneratedRecordId;
            }}
            extraProps={{ scroll: { x: 900 } }}
            pagination={{
              showSizeChanger: false,
              defaultPageSize: 200,
              pageSizeOptions: ['10', '20', '50', '100', '1000']
            }}
          />

        </Card>
      </PageHeaderWrapper>
    );
  }
}

const mapStateToProps = ({ global, router }) => ({
  categories: global.categories,
  search: router.location.search,
  location: router.location,
});

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllInvoices);